import { isMobile } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { Maths } from '../_app/cuchillo/utils/Maths';
import Home from './Home';

export default class About extends Home {
  items = [];
  _itemsShow = [];

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor() {
    super();

    const items = [...GetBy.class('__item', this.container)];
    this.items = Functions.arrayRandom(items);
    this.items.map((item, index) => {
      item.style.setProperty('--index', index);
    });

    const offset = isMobile ? 1 : 0;
    const maxCols = 12;
    const rootStyles = getComputedStyle(this.container);
    const colsWidth = parseInt(rootStyles.getPropertyValue('--cols-width')) || 3;

    let currentCol = 0;

    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      const randomOffset = Maths.maxminRandom(1, 3);

      let colStart = (currentCol + randomOffset);

      console.log({ colStart, currentCol, randomOffset });

      if (colStart + colsWidth + offset > maxCols) {
        colStart = (colStart + colsWidth + offset) % maxCols;
      }

      item.style.setProperty('--colsStart', colStart);

      currentCol = colStart + colsWidth;
    }
    this._itemsShow = [...this.items];
  }
}

ControllerPage._addPage("about", About)
